/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".profile-cta[_ngcontent-%COMP%]{color:#de3838;font-weight:500}"];
export { styles as styles };
